import { redirectToCommericalTrial, redirectToContractSales } from 'businessCommon/src/services';
import { commonLang, _lang, lang, dupLang, isLang, getCurrentLang } from '@umu/ukit-lang';
import React, { Fragment } from 'react';
import { IEditionItem, IPlanInfo, PLAN_TYPE, VERSION_TYPE } from '@umu/umu-types';
import { businessEdition, trackEvent } from '../../../utils/util';

import { PreImg, Button, If } from 'common/src/components';
import { HideInApp, ShowInApp } from '../../hideInApp';
const localeLang = getCurrentLang();
const closeImg = require(`../../../images/close.png`);
import { setStatLogDialogs } from '@umu/umu-api';

import { ACTION_TYPE, DEVICE_FROM_MAP } from '@umu/umu-api/src/services/payment/paymentEvent';
import { isInApp } from '@umu/umu-ua';
import { numToThousands } from 'utils/util';
const isApp = isInApp();

interface IVersionItemProps {
    isRegisterUser: boolean;
    planInfo: IPlanInfo;
    siteHost: string;
    platform: 'twww' | 'mobile';
    teamPricing?: { amount_settle?: number; amount: number };
    onPlan(planId: number, isBuyNow?: boolean): void;
    setShowCommerical(flag: boolean): void;
    redirectInCommerical(): void;
    markStartCommercialTrial(): void;
    getList(list: IEditionItem[]): JSX.Element[];
}

export const CommericalCo = (props: IVersionItemProps) => {
    const {
        platform,
        planInfo,
        setShowCommerical,
        getList,
        isRegisterUser,
        teamPricing = { amount: 0 },
        onPlan,
        redirectInCommerical,
        markStartCommercialTrial,
    } = props;
    const teamPrice = teamPricing.amount || teamPricing.amount_settle || 4000;
    const teamPriceFormat = numToThousands(teamPrice);
    const teamYearPriceFormat = numToThousands(teamPrice * 12);

    const isPc = platform === 'twww';
    // 默认是 en，这样符合大多数语言
    let recommendBackgroundImageCls = 'recommend-en';
    if (isLang('cn')) {
        recommendBackgroundImageCls = 'recommend-cn';
    } else if (isLang('jp')) {
        recommendBackgroundImageCls = 'recommend-jp';
    } else if (isLang('ko')) {
        recommendBackgroundImageCls = 'recommend-ko';
    } else if (isLang('tw')) {
        recommendBackgroundImageCls = 'recommend-tw';
    }

    return (
        <div className={`version-item version-item-commer-co ${isPc ? 'shop-version' : 'version-m-item'}`}>
            <div className={`recommend ${recommendBackgroundImageCls}`}></div>
            <div className="version-item-title">
                <span
                    dangerouslySetInnerHTML={{
                        __html: dupLang('团队版', 'src/plan/@planPricingCommon/components/@pricingVersion'),
                    }}
                ></span>
                <If condition={!isPc}>
                    <div
                        className="close-wraper"
                        onClick={() => {
                            setShowCommerical(false);
                        }}
                    >
                        <PreImg>
                            <img className="close-version" src={closeImg} alt="" />
                        </PreImg>
                    </div>
                </If>
            </div>
            <div className="version-item-des">{lang('为团队学员购买账户')}</div>
            <div className="version-item-price">
                <HideInApp>
                    <div className="price-des">
                        <div className="unit-price-wrapper">
                            <div className="unit-price-number">{teamPriceFormat}</div>
                            <div className="unit-price-text">
                                円
                                <If condition={localeLang === 'jp'}>
                                    <div className="unit-price-tax">（税込）</div>
                                </If>
                            </div>
                        </div>
                        <If condition={localeLang === 'jp'}>
                            <div className="jp-des">月額換算/1アカウントあたり</div>
                        </If>
                        <If condition={localeLang === 'en'}>
                            <div className="jp-des">（tax included）/account</div>
                        </If>
                        <div
                            className="unit-price-des"
                            dangerouslySetInnerHTML={{
                                __html: isLang('jp')
                                    ? '※最低10アカウント以上のご契約が必要<br>（年額{$0}円〜/年払いの場合別途割引有り）'.replace(
                                          '{$0}',
                                          teamYearPriceFormat,
                                      )
                                    : lang(
                                          '※最低10アカウント以上のご契約が必要 （年額{$0}円〜/年払いの場合別途割引有り）',
                                          teamYearPriceFormat,
                                      ),
                            }}
                        ></div>
                    </div>
                </HideInApp>
                <div className="price-button">
                    {/* todo 使用中情况 */}
                    <ShowInApp>
                        <Button
                            className="price-edition-btn"
                            alias="striking"
                            onClick={() => {
                                setStatLogDialogs({ page_type: 16, action_type: '3' });
                                trackEvent(ACTION_TYPE.CLICK_CONTRACT, DEVICE_FROM_MAP[platform]);
                                redirectToContractSales(platform);
                            }}
                        >
                            {commonLang('联系销售')}
                        </Button>
                    </ShowInApp>
                    <If condition={!isApp && !isRegisterUser}>
                        <>
                            <Button
                                className="price-edition-btn now-buy-btn"
                                alias="striking"
                                onClick={() => {
                                    trackEvent(ACTION_TYPE.CLICK_FREE, DEVICE_FROM_MAP[platform]);
                                    redirectToCommericalTrial(platform, isRegisterUser);
                                }}
                            >
                                {commonLang('免费试用')}
                            </Button>
                            <div>
                                <span className="price-edition-texts">{lang('或')}&nbsp;</span>
                                <Button
                                    className="price-edition-text"
                                    alias="text"
                                    onClick={() => {
                                        trackEvent(ACTION_TYPE.CLICK_BUSINESS, DEVICE_FROM_MAP[platform]);
                                        onPlan(PLAN_TYPE.COMMERICAL, true);
                                    }}
                                >
                                    {commonLang('立即购买')}
                                </Button>
                            </div>
                        </>
                    </If>
                    <If condition={!isApp && isRegisterUser && planInfo.plan_id < 3}>
                        <Fragment>
                            <Button
                                className="price-edition-btn now-buy-btn"
                                alias="striking"
                                onClick={() => {
                                    trackEvent(ACTION_TYPE.CLICK_BUSINESS, DEVICE_FROM_MAP[platform]);
                                    onPlan(PLAN_TYPE.COMMERICAL, true);
                                }}
                            >
                                {commonLang('立即购买')}
                            </Button>
                            <If condition={planInfo.business_free_trial === 1}>
                                <div>
                                    <span className="price-edition-texts">{lang('或')}&nbsp;</span>
                                    <Button
                                        className="price-edition-text"
                                        alias="text"
                                        onClick={() => {
                                            trackEvent(ACTION_TYPE.CLICK_FREE, DEVICE_FROM_MAP[platform]);
                                            markStartCommercialTrial();
                                            redirectToCommericalTrial(platform, isRegisterUser);
                                        }}
                                    >
                                        {commonLang('免费试用')}
                                    </Button>
                                </div>
                            </If>
                        </Fragment>
                    </If>

                    <If
                        condition={
                            !isApp &&
                            // tslint:disable-next-line:max-line-length
                            isRegisterUser &&
                            planInfo.plan_id === 3 &&
                            planInfo.teacher_status === VERSION_TYPE.COMMERICAL
                        }
                    >
                        <Button className="price-edition-btn" alias="striking" onClick={redirectInCommerical}>
                            {commonLang('正在使用')}
                        </Button>
                    </If>
                    <If
                        condition={
                            !isApp &&
                            // tslint:disable-next-line:max-line-length
                            isRegisterUser &&
                            planInfo.plan_id === 3 &&
                            planInfo.teacher_status === VERSION_TYPE.COMMERICAL_TRIAL
                        }
                    >
                        <Button
                            className="price-edition-btn now-buy-btn"
                            alias="striking"
                            onClick={() => {
                                trackEvent(ACTION_TYPE.CLICK_BUSINESS, DEVICE_FROM_MAP[platform]);
                                onPlan(PLAN_TYPE.COMMERICAL, true);
                            }}
                        >
                            {commonLang('立即购买')}
                        </Button>
                    </If>
                </div>
            </div>
            <div className="version-item-content">
                <div
                    className="content-title"
                    dangerouslySetInnerHTML={{
                        __html: isLang('jp')
                            ? '小規模チーム向け<br>学習プラットフォーム：'
                            : lang('小規模チーム向け学習プラットフォーム：'),
                    }}
                ></div>
                <div className="content-list">{getList(businessEdition)}</div>
            </div>
        </div>
    );
};
